import styled from "styled-components";

export const StyledWrapper = styled.div`
    .StyledTable {
        padding-bottom: 0;
    }

    .StyledTable .MiniFlexTable-column {
        & .MiniFlexTable-headerCell {
            padding: 20px 12px 12px;
            height: fit-content;
        }

        & .MiniFlexTable-cell {
            padding: 6px 12px;
            height: 47px;
            box-sizing: content-box;
        }
    }
`;
